/* SearchResultPage.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { AppTile, PaginatedAppGrid, usePaginatedAppGrid } from '@atlassian/mpac-app-tile';
import { useFeatureFlags } from '@atlassian/mpac-feature-flags';
import { Breadcrumbs, BreadcrumbsItem, FluidContainer } from '@atlassian/mpac-primitives';
import { GetAppSearch } from '@atlassian/mpac-services-client';
import { RedirectionUrlsUtils, useAlgoliaConfig, useHostUrl, useSource, WindowUtils } from '@atlassian/mpac-utils';
import React, { useCallback, useEffect, useState } from 'react';
import { resolveAlgoliaSearchIndex } from '../SearchUtils';
import { TEST_IDS } from '../testIds';
const _ = "._1yt48dri{padding:var(--ds-space-400) 0 var(--ds-space-800) 0}";
const SearchPageContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = FluidContainer,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1yt48dri", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  SearchPageContainer.displayName = 'SearchPageContainer';
}
const SearchResultPage = () => {
  const {
    enableV2SearchIndex
  } = useFeatureFlags();
  const [searchQuery, setSearchQuery] = useState('');
  const hostUrl = useHostUrl();
  const source = useSource();
  const algoliaConfig = useAlgoliaConfig();
  const searchIndex = resolveAlgoliaSearchIndex(algoliaConfig.environment, enableV2SearchIndex);
  const {
    appList,
    totalCount,
    isLoading,
    isLoadingMore,
    showEndReached,
    showLoadMore,
    fetchInitialApps,
    fetchMoreApps
  } = usePaginatedAppGrid({
    query: GetAppSearch,
    parseResponse: data => {
      var _data$appSearch, _data$appSearch$apps, _data$appSearch$apps$, _data$appSearch2, _data$appSearch2$apps, _data$appSearch3, _data$appSearch3$apps;
      return {
        appList: (data === null || data === void 0 ? void 0 : (_data$appSearch = data.appSearch) === null || _data$appSearch === void 0 ? void 0 : (_data$appSearch$apps = _data$appSearch.apps) === null || _data$appSearch$apps === void 0 ? void 0 : (_data$appSearch$apps$ = _data$appSearch$apps.edges) === null || _data$appSearch$apps$ === void 0 ? void 0 : _data$appSearch$apps$.map(edge => edge.node)) || [],
        hasNextPage: Boolean(data === null || data === void 0 ? void 0 : (_data$appSearch2 = data.appSearch) === null || _data$appSearch2 === void 0 ? void 0 : (_data$appSearch2$apps = _data$appSearch2.apps) === null || _data$appSearch2$apps === void 0 ? void 0 : _data$appSearch2$apps.pageInfo.hasNextPage),
        totalCount: (data === null || data === void 0 ? void 0 : (_data$appSearch3 = data.appSearch) === null || _data$appSearch3 === void 0 ? void 0 : (_data$appSearch3$apps = _data$appSearch3.apps) === null || _data$appSearch3$apps === void 0 ? void 0 : _data$appSearch3$apps.pageInfo.totalCount) || 0
      };
    }
  });
  useEffect(() => {
    fetchInitialApps({
      variables: {
        query: searchQuery,
        algoliaAppKey: algoliaConfig.apiKey,
        algoliaAppId: algoliaConfig.applicationId,
        algoliaSearchIndex: searchIndex,
        after: 0,
        first: 24
      }
    });
  }, [searchQuery, fetchInitialApps, algoliaConfig.apiKey, algoliaConfig.applicationId, searchIndex]);
  const onTileClick = useCallback(appKey => {
    const appListingUrl = RedirectionUrlsUtils.getAppListingUrl(source, hostUrl, appKey);
    WindowUtils.openPage(appListingUrl, '');
  }, [source, hostUrl]);
  return /*#__PURE__*/React.createElement(SearchPageContainer, null, /*#__PURE__*/React.createElement(Breadcrumbs, {
    testId: TEST_IDS.SEARCH_PAGE_BREADCRUMBS
  }, /*#__PURE__*/React.createElement(BreadcrumbsItem, {
    href: "/",
    text: "Marketplace"
  }), /*#__PURE__*/React.createElement(BreadcrumbsItem, {
    text: "Search"
  })), /*#__PURE__*/React.createElement("input", {
    type: "text",
    value: searchQuery,
    onChange: e => setSearchQuery(e.target.value)
  }), !isLoading && /*#__PURE__*/React.createElement("div", null, "Results found for ", searchQuery, " : ", totalCount), /*#__PURE__*/React.createElement(PaginatedAppGrid, {
    isLoading: isLoading,
    isLoadingMore: isLoadingMore,
    onLoadMoreClick: () => fetchMoreApps && fetchMoreApps({
      variables: {
        after: appList.length,
        first: 12
      }
    }),
    showLoadMore: showLoadMore,
    renderGrid: () => appList.map((app, index) => /*#__PURE__*/React.createElement(AppTile, {
      key: index,
      tileData: app,
      environment: "local",
      source: "MPAC",
      onTileClick: onTileClick
    }))
  }), showEndReached && /*#__PURE__*/React.createElement("div", null, "End reached. Apps rendered on screen = ", appList.length));
};
export default SearchResultPage;